import ElementModel from '../models/ElementModel';
import IService from './IService';
import Axios from 'axios';

export default class ElementService implements IService<ElementModel> {

    constructor() {
    }

    async list(filter: any) {
        const data = [];
        var res = await Axios.post('/api/Elements/list', filter)
        .then(res => {
            if (res.data.success) {
                let obj = res.data.data.map((itm: any) => {
                    let ret = new ElementModel();
                    ret.idNElemento = itm.idNElemento;
                    ret.fkNSupervisor = itm.fkNSupervisor;
                    ret.fkNTipoElemento = itm.fkNTipoElemento;
                    ret.fkNAgrupacionElemento = itm.fkNAgrupacionElemento;
                    ret.fldTNombre = itm.fldTNombre;
                    ret.fldBVisibleEnPortada = itm.fldBVisibleEnPortada;
                    ret.fldBActivo = itm.fldBActivo;

                    return ret;
                });
                let result = {
                    success: true,
                    data: obj
                }
                return result;
            }
            return null;
        }).catch(error => {
            let result = {
                success: false,
                Message: error.response.data.responseErrorMessage
            }
            return result;
        });
        return res;
    }

    async insert(data: ElementModel) {
        var res = await Axios.post('/api/Elements/insert', data);
        return res.data;
    }

    async update(data: ElementModel) {
        var res = await Axios.put('/api/Elements/update', data);
        return res.data;
    }

    async delete(data: ElementModel) {
        var res = await Axios.delete('/api/Elements/delete?id=' + data.idNElemento);
        return res.data;
    }

    async export(filter: any) {
        var res = await Axios.post('/api/Elements/export', filter, {
            responseType: 'blob'
        });
        return res.data;
    }

    async listByInstalation(id: number, graficables: number) { //Si variable es graficable => graficables = 1, caso contrario graficables = 0
        if (graficables == 1) {
            var resG = await Axios.get('/api/Elements/listbyinstalationonlygraph?id=' + id);
            return resG.data;
        }
        else {
            var res = await Axios.get('/api/Elements/listbyinstalation?id=' + id);
            return res.data;
        }
    }

    async getGlobalData(idI: number, idE: number) {
        var res = await Axios.get('/api/Elements/getglobaldata', { params: { idInstalacion : idI , idElemento : idE } });
        return res.data;
    }

    async get(id: number) {
        var res = await Axios.get('/api/Elements/get', {
            params: {
                id: id
            }
        });
        if (res.data.success) {
            return res.data;
        }
        return null;
    }

}